import { moment } from "@/config/vue/plugins/moment.js";

const ONE_HOUR_IN_MS = 60 * 60 * 1000;

const timeFormat = (timeMs) => {
  return timeMs >= ONE_HOUR_IN_MS ? "H:mm:ss" : "m:ss";
};

const formatDuration = (durationMs) => {
  if (!durationMs) return null;

  return moment.utc(durationMs).format(timeFormat(durationMs));
};

export { formatDuration };
